import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Component, DoCheck, EventEmitter, Input, KeyValueDiffer, KeyValueDiffers, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Store } from '@ngrx/store';
import { I18NextPipe } from "angular-i18next";
import * as moment from 'moment';
import { State } from 'src/app/dashboards/state';
import { widgetType } from 'src/app/enums';
import { BaseWebEngageReportsSettingsComponent } from 'src/app/reports/reports-details/nested-components/reports-web-engage-settings/base/base-web-engage-reports-settings.component';
import { DashboardService } from "src/app/services/services/dashboard.service";

@Component({
    selector: 'app-web-engage-reports-settings',
    templateUrl: './web-engage-reports-settings.component.html',
    styleUrls: ['./web-engage-reports-settings.component.scss'],
    animations: [
        trigger('collapse', [
            state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
            state('true', style({ height: '0', visibility: 'hidden' })),
            transition('false => true', animate('200ms ease-in')),
            transition('true => false', animate('200ms ease-out'))
        ])
    ],
    standalone: false
})

export class WebEngageReportsSettingsComponent extends BaseWebEngageReportsSettingsComponent implements OnInit, DoCheck  {

  @Input() rdp_data: any;
  @Input() columns: any[];
  @Input() settingsExpanded: boolean;
  @Input() showColumnButton: boolean;
  @Input() isFromDashboard: boolean;
  @Output() public completedNotifier = new EventEmitter<boolean>();
  @Output() public columnOrderChangedNotifier = new EventEmitter<string[]>();
  @Output() rdp_dataChange = new EventEmitter<any>();

  defaultColumns: any[] = [];
  initialGridItemType: widgetType;
  rulesMultiselectIsOpen: boolean;
  interactionsMultiselectIsOpen: boolean;
  private rdp_dataDiffer: KeyValueDiffer<string, any>;
  isInit : boolean = true;

  get isViewButtonVisible(): boolean {
    let setup = this.gridItem.setup;
    let selectedNonKeyColumns = this.columns?.filter(c => setup.columns.includes(c.labelCode) && !c.isKey) || [];
    return setup.columns && selectedNonKeyColumns.length > 0 && this.gridItem.type != null;
  }

  constructor(protected dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe, public dialog: MatDialog, protected store: Store<State>,
    private differs: KeyValueDiffers  ) {
    super(dashboardsService, i18nextPipe);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.report.subReportId > 0 || this.isFromDashboard) {
      this.gridItem.setup.columns = this.report.defaultColumns;
      this.notifyReportModified();
    } else {
      this.gridItem.setup.columns = this.columns.map(col => col.labelCode);
    }

    if (this.isInit && this.isFromDashboard) {
      this.isInit = false;
      this.loadRulesAndInteractions(moment.utc().add(-2, "y").toDate(), moment.utc().toDate());
      this.setDisabledColumns(this.gridItem.setup.period.from, this.gridItem.setup.period.to);
    }


    this.rdp_dataDiffer = this.differs.find(this.rdp_data).create();
  }

  // rdp_data is changed on deeper level so it cannot be detected by ngOnChanges
  ngDoCheck(): void {
    const changes = this.rdp_dataDiffer.diff(this.rdp_data);
    if (changes) {
      this.rdp_dataChange.emit(this.rdp_data);
    }
  }

  viewReport() {
    this.completedNotifier.emit();
  }

  columnOrderEvent(columns: string[]) {
    this.columnOrderChangedNotifier.emit(columns);
  }

  setPeriod($event) {
    this.gridItem.setup.period = $event;
    let period = this.gridItem.setup.period;
    let from = period.from;
    let to = period.to;
    if (this.isInit && (this.report.subReportId > 0 || this.isFromDashboard)) {
      this.isInit = false;
      from = moment.utc().add(-2, "y").toDate();
      to = moment.utc().toDate();
    }
    this.loadRulesAndInteractions(from, to);
    this.setDisabledColumns(period.from, period.to);
  }

  rulesModelChanged(selectedItemIds) {
    this.gridItem.setup.ruleIds = selectedItemIds;
    let period = this.gridItem.setup.period;
    this.loadInteractions(selectedItemIds, period.from, period.to);
    this.visualTypeCheck();
    this.notifyReportModified();
  }

  groupingModelChange(args) {
    let period = this.gridItem.setup.period;
    this.setDisabledColumns(period.from, period.to);
    this.visualTypeCheck();
    this.notifyReportModified();
  }

  visualTypeModelChange(visualType) {
    this.gridItem.type = visualType;
    this.notifyReportModified();
  }
}
